import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

interface IDropAcknowledgement {
  partnerId: string
  fYear: number
  programType: string
  comment: string
  ownerId: string
}

export const dropAcknowledgement = async ({
  partnerId,
  comment,
  programType,
  fYear,
  ownerId,
}: IDropAcknowledgement) => {
  try {
    const url = proxy('/webservice/621/sp/v3/spJBPCommitmentDrop/call')

    const [accessToken] = getTokens(ownerId)
    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    const payload = {
      'p.PartnerId': partnerId,
      'p.FYear': fYear,
      'p.ProgramType': programType,
      'p.Comment': comment,
    }

    const response = await Rest.post({ url, payload, headers })
    return Boolean(response && response.Rows)
  } catch {
    return false
  }
}
